<div id="campus-facilities" class="inner-page py-5 bg-light">
  <div class="container px-lg-5">

    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-dark mb-2">Campus Facilities</h1>
      <p class="lead text-muted">Click on any directory folder below to explore high-definition showcases of our campus infrastructure.</p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: #1c5c3e; border: none; opacity: 1;">
    </div>

    <!-- Grid of Folders -->
    <div class="row g-4 justify-content-center">
      <div class="col-12 col-md-6 col-lg-4" *ngFor="let facility of facilities; let i = index">
        
        <div class="folder-wrapper" (click)="openFolder(i)">
          <!-- Folder Tab -->
          <div class="folder-tab-header">
            <span class="folder-tab-title">{{ facility.name }}</span>
            <span class="file-count-tag">{{ facility.thumbs.length }} Photos</span>
          </div>

          <!-- Folder Main Cover Body -->
          <div class="folder-body-card">
            <!-- Simulated Peeking Album Images inside the folder -->
            <div class="peeking-paper paper-back">
              <img *ngIf="facility.thumbs[2]" [src]="facility.thumbs[2]" class="peeking-img">
            </div>
            <div class="peeking-paper paper-middle">
              <img *ngIf="facility.thumbs[1]" [src]="facility.thumbs[1]" class="peeking-img">
            </div>
            <div class="peeking-paper paper-front">
              <img [src]="facility.thumbs[0]" class="peeking-img main-cover-img">
            </div>

            <!-- Folder Title Strip Label -->
            <div class="folder-label-card">
              <div class="folder-label-icon">
                <!-- SVG Folder Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-folder2-open" viewBox="0 0 16 16">
                  <path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.842.94 1.502v5.474a1.5 1.5 0 0 1-1.496 1.496H1.5A1.5 1.5 0 0 1 0 13.112V4.5A1.5 1.5 0 0 1 1 3.5zM2.5 3a.5.5 0 0 0-.5.5v3.978c.534-.318 1.174-.478 1.82-.478h9.86a.5.5 0 0 0 .5-.5V5.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5zM3.82 8a1.5 1.5 0 0 0-1.32 1h10.999a1.5 1.5 0 0 0-1.319-1H3.82z"/>
                </svg>
              </div>
              <div class="folder-label-text">
                <span class="label-heading">{{ facility.name }}</span>
                <span class="label-sub">Directory Album</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Custom Cinematic Lightbox Showcase -->
  <div class="lightbox-overlay" *ngIf="isLightboxOpen" (click)="closeLightbox()">
    
    <!-- Top Bar Controls -->
    <div class="lightbox-top-bar d-flex justify-content-between align-items-center px-4 py-3" (click)="$event.stopPropagation()">
      <div class="lightbox-title text-white">
        <h5 class="mb-0 fw-bold text-uppercase tracking-wider text-orange-light">{{ facilities[activeFolderIndex].name }}</h5>
        <span class="small opacity-75">Viewing Photo {{ activeImageIndex + 1 }} of {{ facilities[activeFolderIndex].thumbs.length }}</span>
      </div>
      <button class="btn-close-lightbox" (click)="closeLightbox()">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854z"/>
        </svg>
      </button>
    </div>

    <!-- Main Active Display Area -->
    <div class="lightbox-stage d-flex align-items-center justify-content-center">
      <!-- Prev Button -->
      <button class="nav-arrow nav-prev" (click)="prevImage($event)">
        &#8249;
      </button>

      <!-- Stage Image Container -->
      <div class="stage-image-container position-relative" (click)="$event.stopPropagation()">
        <img [src]="facilities[activeFolderIndex].thumbs[activeImageIndex]" 
             class="img-fluid rounded-3 shadow-lg lightbox-main-img animate-fade"
             alt="Showcase">
      </div>

      <!-- Next Button -->
      <button class="nav-arrow nav-next" (click)="nextImage($event)">
        &#8250;
      </button>
    </div>

    <!-- Bottom Thumbnail Strip Showcase -->
    <div class="lightbox-bottom-strip py-3 px-4" (click)="$event.stopPropagation()">
      <div class="d-flex justify-content-center align-items-center gap-2 overflow-auto py-1">
        <div *ngFor="let thumb of facilities[activeFolderIndex].thumbs; let j = index"
             class="strip-thumbnail-item"
             [class.active-item]="activeImageIndex === j"
             (click)="setImageIndex(j, $event)">
          <img [src]="thumb" class="strip-img" [alt]="facilities[activeFolderIndex].name">
        </div>
      </div>
    </div>

  </div>
</div>
